import React, { Fragment, useState, useEffect } from 'react';

import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
// import { submitForm } from './search/redux/actions/actions';
import { useTranslation } from 'react-i18next';

import Cookies from 'js-cookie';
import { loadSanadBranding } from '../utils/loadSanadBranding';

const {config}=require("../../api/api")

function SanadVisaPayment() {
   

    const [options, setCountries] = useState([]);
    const base_url = config.baseURL;
    const redirect_url=config.redirectURL;
    const [searchResult,setSearchResult]=useState(null);
    const [orderData,setOrderData]=useState(null);
    const [userData,setUserData]=useState(null);
    const [loading,setLoading]=useState(false);
    const [orderId,setOrderId]=useState(null);
    const [openPaymentTable,setOpenPaymentTable]=useState(false);
    
    const vendorKey = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';


     const [OrderDetails, setOrderDetails] = useState('');
        const [OrderID, setOrderID] = useState('');
        const [CreatedDate, setCreatedDate] = useState('');
        const [PaymentStatus, setPaymentStatus] = useState('');
        const [OrderSts, setOrderSts] = useState('');
        const [ApplicationSts, setApplicationSts] = useState('');
        const [ApplicationID, setApplicationID] = useState('');
        const [ProcessingSts, setProcessingSts] = useState('');
        const [userDetails,setUserDetails]=useState(null);
    
    useEffect(() => {

    loadSanadBranding();

  }, []);

    useEffect(()=>{
      // const search_result=sessionStorage.getItem("programs");
      // if(search_result){
      //   const search_parse=JSON.parse(search_result);
      //   setSearchResult(search_parse);
      // }

      const order_info=sessionStorage.getItem("user_details");
      if(order_info){
        const order_parse=JSON.parse(order_info);
        setOrderData(order_parse);
      }

      // const order_id=sessionStorage.getItem("event_data");
      // if(order_id){
      //   const order_id_parse=JSON.parse(order_id);
      //   setOrderId(order_id_parse?.orderId);
      // }
        },[])

  const urlSearchString = window.location.search;

    const uparams = new URLSearchParams(urlSearchString);

          useEffect(() => {

        if (vendorKey !== '') {
           
           try{
            setLoading(true)
            var GivenData = {
                'order_id': uparams.get('order_id')
            }

            var vkData = GivenData;
            // debugger

            fetch(base_url+'/get_sanad_visa_order_details', {
                method: 'POST',
                headers: {
                    "Authorization":"Bearer "+vendorKey,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(vkData)
            })
                .then(response => response.json())
                .then(data => {
                    // debugger
                    console.log(data.result.order)
                    setOpenPaymentTable(true);
                    setOrderDetails(data.result.order)
                    setOrderID(data.result.order.id)
                    setCreatedDate(data.result.order.created_at)
                    setPaymentStatus(data.result.order.payment_status)
                    setOrderSts(data.result.order.order_status)
                    setApplicationSts(data.result.order.applications[0].application_status)
                    setApplicationID(data.result.order.applications[0].id)
                    setProcessingSts(data.result.order.applications[0].processing_status)

                })
                .catch(error => {
                    console.error('Error posting data:', error);
                });
            }catch(err){
                console.error("err : "+err);
            }
            finally{
                setTimeout(()=>{
                   setLoading(false);
                },1000)
            }
        }
    }, [ vendorKey, uparams.get('order_id')]);



    const textLabel = {
        display: "flex",
        alignItems: "center",
        padding: ".375rem .75rem",
        marginBottom: "0",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5",
        color: "#495057",
       flexWrap:"wrap",
        backgroundColor: "",

        borderRadius: ".25rem"
    }
    const labelStyle = {
        backgroundColor: "#FFF2E6",
        width: "50%",
        border: "1px solid #ced4da",
        borderTopLeftRadius: "5px",
        borderBottomLeftRadius: "5px"

    }

    const handleSubmit = async (e) => {
        // debugger
        e.preventDefault();


        
        console.log(searchResult);
        // console.log(searchData);
        setLoading(true);
        const rand = Math.floor(Math.random() * 90000000) + 10000000;
        const rnd = rand.toString();
        const  usrtok=orderData?.access_token;
       const data = {
            "order_id":OrderDetails.order_id,
            "amount_cents": OrderDetails.fee,
            "reference_id": rnd,
            "is_live": "true",
            "first_name": OrderDetails.first_name,
            "last_name":OrderDetails.last_name,
            "phone_no": OrderDetails.phone,
            "apartment": OrderDetails.apartment || "",
            "floor": OrderDetails.floor|| "",
            "street": OrderDetails.street || "",
            "city": OrderDetails.city || "",
            "state": OrderDetails.state || "",
            "country": OrderDetails.country,
            "email": OrderDetails.email,
            "save_selection": "true",
            "redirection_url": base_url+"/payment_status_info_sanad",
            "currency": OrderDetails.currency,
            "description": "Payment visa **",
            "vendor_key":vendorKey
          };
       
    // debugger
    if (vendorKey !== ''&&usrtok!=='') {
    
      fetch(base_url+'/generate_payment_link_sanad', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${usrtok}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          // debugger
          if(data.message==="success"){
            window.location.href = data.result?.client_url;
          }
    
          // setpKey(data.result.payment_token);
    
    
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });
    
    }  
      };


    return (
    <>
<div className="row " style={{height: "80vh",alignContent:"center"}}>
                            
<div className="col-lg-3"></div>
{
  openPaymentTable && <div className="col-lg-6">
<div className='d-flex justify-content-center '>
<div className=' d-flex justify-content-between mb-2'style={{width:"90%"}}>

                                      <h1>Make Payment </h1>
                                
                                  <h1>
                                قم بالدفع 
                                </h1>
                                
                                  </div>
                                  </div>
<div className=" d-flex justify-content-center" style={{width:"100%"}}>
<table className=" px-2" style={{width:"90%"}}>
<tbody >
    <tr>
        <td className='border px-2 py-2'>
{'First Name'}
        </td>
        <td className='border px-2 py-2'>
{OrderDetails?.first_name}  
        </td>
    </tr>
    <tr>
        <td className='border px-2 py-2'>
{'Last Name'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails?.last_name}  
        </td>
    </tr>
     <tr>
        <td className='border px-2 py-2'>
{'Email'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails?.email}  
        </td>
    </tr>
      <tr >
        <td className='border px-2 py-2'>
{'Passport Country'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails?.arrival}  
        </td>
    </tr>
      <tr >
        <td className='border px-2 py-2'>
{'Destination Country'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails?.destination}  
        </td>
    </tr>
      <tr >
        <td className='border px-2 py-2'>
{'Fee'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails.fee_omr || OrderDetails?.fee}  
        </td>
    </tr>
      <tr>
        <td className='border px-2 py-2'>
{'Currency'}
        </td>
        <td className='border px-2 py-2'>
           {OrderDetails.fee_omr?"OMR ":OrderDetails?.currency}  
        </td>
    </tr>
</tbody>
</table>
</div>

{
  OrderDetails?.payment_status?.toLowerCase().trim() !== "success" &&
<div className='mt-4 d-flex justify-content-center '>
    <button type ="submit" onClick={(e)=>handleSubmit(e)} >{"Make Payment"}</button>
</div>  

}                 
                
</div>
}
<div className="col-lg-3">

</div>
</div>
{
  loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )
}

    </>
    
    )
}
export default SanadVisaPayment;